import { Injectable } from '@nestjs/common';
import { PrismaService } from './prisma/prisma.service';

@Injectable()
export class AppService {
  constructor(private readonly prisma: PrismaService) {}

  async getHealth(): Promise<{ status: string; service: string; database: 'connected' | 'unreachable' }> {
    let database: 'connected' | 'unreachable' = 'unreachable';

    try {
      await this.prisma.$queryRaw`SELECT 1`;
      database = 'connected';
    } catch {
      database = 'unreachable';
    }

    return {
      status: database === 'connected' ? 'ok' : 'degraded',
      service: 'chat-service',
      database,
    };
  }
}
